import Raven from 'raven-js';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetOAuthPortalPickerResponseForPortalQuery } from '../../../../__generated__/chirp/com/hubspot/applications/rpc/ApplicationsInstallRpc.hooks';
import { isValidClientId } from '../../../utils/authUtils';
import { queryResultToRequestStatus } from '../../../utils/dataFetchingClientUtils';
import { getAuthorizationRequestInfo } from '../../../utils/urls';
export const useFetchCurrentAccount = () => {
  const location = useLocation();
  const authorizationRequestInfo = useMemo(() => getAuthorizationRequestInfo(location.search), [location.search]);
  const clientId = authorizationRequestInfo.clientId;
  const {
    data,
    loading,
    error
  } = useGetOAuthPortalPickerResponseForPortalQuery({
    variables: {
      clientId
    },
    skip: !isValidClientId(clientId),
    onError: e => {
      Raven.captureException(e, {
        extra: {
          message: 'There was a problem fetching the account details',
          clientId
        }
      });
    }
  });
  return {
    data,
    loading,
    error,
    requestStatus: queryResultToRequestStatus({
      hasData: !!data,
      loading,
      error
    })
  };
};